import { Controller } from "@hotwired/stimulus"

// duplicates fieldset in nested forms by calling `#dup`
// can be nested: fieldset closest to event target will be duplicated
export default class extends Controller {
  dup(event) {
    const srcNode = event.target.closest('fieldset')
    const newNode = srcNode.cloneNode(true)

    this._updateAttrsWithNewId(srcNode, newNode)
    this._removeIdNodes(newNode)

    srcNode.after(newNode)

    this._setFocus(newNode)
  }

  // generate id and update attributes:
  // - name - to create new record via nested attributes
  // - id - uniqeness in DOM required
  _updateAttrsWithNewId(srcNode, newNode) {
    const newId = new Date().valueOf();

    const input = srcNode.querySelector("input[name]")

    const srcNamePrefix = input.name.replace(/\[\w+\]$/, "") // without attribute
    const newNamePrefix = srcNamePrefix.replace(/\[\d+\]$/, `[${newId}]`); // with new id

    const srcIdPrefix = input.id.replace(/[a-z_]+$/, "")
    const newIdPrefix = srcIdPrefix.replace(/\d+$/, newId)

    newNode.querySelectorAll(`[name^="${srcNamePrefix}"]`).forEach((node) => {
      node.name = node.name.replace(srcNamePrefix, newNamePrefix)
      node.id = node.id.replace(srcIdPrefix, newIdPrefix)
    })
  }

  // all existing ids are not relevant - new records should be created
  _removeIdNodes(newNode) {
    newNode.querySelectorAll('[name$="[id]"]').forEach((node) => {
      node.remove()
    });
  }

  _setFocus(newNode) {
    setTimeout(() => {
      newNode.querySelector("input:not([type=hidden]").focus()
    })
  }
}
